import { Formik, Form } from 'formik'
import {
  CurrencyInputField,
  InputField,
  InputSelectOptions,
  LoaderButton
} from 'components/molecules'
import PropTypes from 'prop-types'
import TlBankSelectSearchField from 'domains/tl-banks/molecules/select-search-field/tl-bank-select-search-field'
import fastSellPaymentFormInitialValues from './fast-sell-payment-form-initial-values'
import fastSellPaymentSchema from './fast-sell-payment-form-schema'
import { Col } from 'reactstrap'
import { PAYMENT_STATUS } from 'domains/fast-sell-payment/constants'
const propTypes = {
  onClickSubmit   : PropTypes.func,
  fastSellProduct : PropTypes.object,
  disabled        : PropTypes.bool
}

const defaultProps = {
  onClickSubmit : () => { },
  disabled      : false
}

const FastSellPaymentForm = ({
  onClickSubmit,
  fastSellProduct,
  disabled
}) => (
  <Formik
    initialValues={ fastSellPaymentFormInitialValues({ fastSellProduct }) }
    enableReinitialize={ true }
    onSubmit={ onClickSubmit }
    validationSchema={ fastSellPaymentSchema }
  >
    {
      (formik) => (
        <Form className='row'>
          <Col>
            <InputField
              type={ 'input' }
              name={ 'credit_bank_name' }
              label={ 'Credit Bank Name' }
              required={ true }
              formText={ 'Bank tujuan (contoh: BCA, Mandiri, BNI, dll)' }
              disabled={ disabled }
            />

            <InputField
              type={ 'input' }
              name={ 'credit_bank_branch' }
              label={ 'Credit Bank Branch' }
              required={ true }
              formText={ 'Cabang Bank tujuan' }
              disabled={ disabled }
            />

            <InputField
              type={ 'input' }
              name={ 'credit_bank_account_name' }
              label={ 'Credit Bank Account Name' }
              required={ true }
              formText={ 'Nama pemilik rekening bank tujuan' }
              disabled={ disabled }
            />

            <InputField
              type={ 'input' }
              name={ 'credit_bank_account_no' }
              label={ 'Credit Bank Account No' }
              required={ true }
              formText={ 'No. rekening bank tujuan' }
              disabled={ disabled }
            />
          </Col>

          <Col>
            <InputField
              label='Transferred At'
              name='transferred_at'
              type='date'
              required={ true }
              formText='format: dd/mm/yy'
              disabled={ disabled }
            />

            <CurrencyInputField
              name={ 'amount' }
              label={ 'Amount' }
              required={ true }
              formText={ 'Nilai dari transfer' }
              disabled={ disabled }
            />

            {
              fastSellProduct.payment?.id && (
                <TlBankSelectSearchField
                  name={ 'debit_bank' }
                  label={ 'Debit Bank' }
                  required={ true }
                  formText={ 'No. Rekening Bank Tinkerlust yang digunakan untuk men-transfer' }
                  disabled={ disabled }
                />
              )
            }

            <InputField
              type={ 'select' }
              name={ 'payment_status' }
              label={ 'Payment Status' }
              formText={ 'Status pembayaran (default: pending)' }
              disabled={ disabled }
            >
              <InputSelectOptions options={ PAYMENT_STATUS }/>
            </InputField>
          </Col>

          <Col xs={ 12 }>
            <LoaderButton
              color='primary'
              className='d-flex float-right'
              type='submit'
              disabled={ formik.isSubmitting || disabled }
              isLoading={ formik.isSubmitting }
              text='Update Payment'
            />
          </Col>

        </Form>
      )
    }
  </Formik>
)

FastSellPaymentForm.propTypes    = propTypes
FastSellPaymentForm.defaultProps = defaultProps

export default FastSellPaymentForm
